CancelModalService = ($window) ->
  startCancellation: ->
    url = encodeURIComponent("/")
    $window.location = "/payment/start_cancellation?return_url=#{url}&start_url=#{url}"

CancelModalService.$inject = [
  '$window'
]

module.exports = CancelModalService




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/cancel-modal/cancel-modal-service.coffee